 import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  // Import one of available themes
  import 'vue-toast-notification/dist/theme-default.css';
  //import 'vue-toast-notification/dist/theme-sugar.css';

  //https://www.npmjs.com/package/vue-toast-notification
  

export default {
  
  async success (message, options={position: 'top-right', duration:3000}) {
    Vue.use(VueToast);
    Vue.$toast.success(message, options)   
  },  
  async error (message,options={position: 'top-right', duration:3000}) {
    Vue.use(VueToast);
    Vue.$toast.error(message,options)   
  },
  async warning (message,options={position: 'top-right', duration:3000}) {
    Vue.use(VueToast);
    Vue.$toast.warning(message, options)   
  },
  async info (message,options={position: 'top-right', duration:3000}) {
    Vue.use(VueToast);
    Vue.$toast.info(message,options)   
  },
  async default (message,options={position: 'top-right', duration:3000}) {
    Vue.use(VueToast);
    Vue.$toast.default(message, options)   
  },

}

